import { useFlags } from "launchdarkly-react-client-sdk";
import { useMemo } from "react";
import { FeatureFlagKey } from "./flags";

export type FlagReadyState<K extends FeatureFlagKey = FeatureFlagKey> = {
  ready: boolean;
  value: boolean;
  key: K;
};

export type UseFlagReadyOptions = {
  defaultValue?: boolean;
};

export const useFlagReady = <K extends FeatureFlagKey>(
  key: K,
  options: UseFlagReadyOptions = {},
): FlagReadyState<K> => {
  const flags = useFlags<Record<FeatureFlagKey, boolean | undefined>>();
  const rawValue = flags[key];
  const { defaultValue = false } = options;
  const ready = typeof rawValue === "boolean";
  const value = ready ? rawValue : defaultValue;

  return useMemo<FlagReadyState<K>>(
    () => ({
      key,
      ready,
      value,
    }),
    [key, ready, value],
  );
};
